export const faqItems = [
  {
    question: '狠狠撸是什么？',
    answer: '狠狠撸是一个海量资源聚合搜索平台，为您提供极速检索、精准匹配、分类浏览等核心功能。我们汇集了学习教育、影视娱乐、软件工具、设计素材、音乐音频、图书文献、游戏资源、生活百科等八大类优质内容资源，帮助您快速定位、高效获取所需内容。',
  },
  {
    question: '狠狠撸的资源是否免费？',
    answer: '狠狠撸平台上的大部分资源均可免费访问和下载。我们致力于打造一个开放、共享的资源平台，让优质内容触手可及。部分精品资源可能需要注册会员后获取。',
  },
  {
    question: '如何在狠狠撸上快速找到我想要的资源？',
    answer: '您可以通过三种方式快速找到资源：一是在首页搜索框输入关键词进行极速检索；二是通过分类浏览页面按类别查找；三是浏览我们的推荐内容和热门榜单。我们的智能匹配算法会帮您精准定位最相关的资源。',
  },
  {
    question: '狠狠撸的资源更新频率如何？',
    answer: '我们的内容团队每日更新平台资源，确保您始终能够获取最新、最热门的内容。热门分类如影视娱乐、软件工具等类目更新尤为频繁，每周新增资源超过500条。',
  },
  {
    question: '我可以在狠狠撸上分享自己的资源吗？',
    answer: '可以的！狠狠撸欢迎用户贡献优质资源。您可以通过平台的资源提交功能上传和分享您的好资源。所有提交的资源经过审核后将会展示在相应分类中，与更多用户分享。',
  },
  {
    question: '如何联系狠狠撸的客服团队？',
    answer: '您可以通过关于我们页面上的联系方式与我们取得联系，包括电子邮箱、在线客服和社交媒体渠道。我们的客服团队在工作日9:00-18:00提供及时的技术支持与咨询服务。',
  },
];

export const statsData = [
  { label: '资源总数', value: '18,562+', icon: 'ri-database-2-line' },
  { label: '每日更新', value: '500+', icon: 'ri-refresh-line' },
  { label: '活跃用户', value: '120万+', icon: 'ri-user-smile-line' },
  { label: '内容分类', value: '8大类', icon: 'ri-stack-line' },
];

export const testimonials = [
  {
    name: '张同学',
    role: '大学生',
    content: '狠狠撸真的太方便了！我找学习资料从来没有这么快过，分类清晰，搜索精准，强烈推荐给所有学生党。',
    rating: 5,
  },
  {
    name: '李设计师',
    role: 'UI设计师',
    content: '设计素材分类里面的资源质量很高，我每天都会来逛逛找灵感，很多免费素材可以直接用，省了不少时间。',
    rating: 5,
  },
  {
    name: '王工程师',
    role: '软件工程师',
    content: '软件工具类目是我最常逛的，各种开发工具和教程都很全面，帮我解决了不少技术难题。',
    rating: 4,
  },
  {
    name: '赵老师',
    role: '中学教师',
    content: '作为老师，我在狠狠撸上找到了大量优质的教学资源，备课效率提高了不少，推荐给教育工作者们。',
    rating: 5,
  },
];